import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Airport } from '../models/airport.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MatSelectChange, MatSnackBar } from '@angular/material';
import { OverviewService } from '../service/overview.service';
import { formatPhoneString, undoPhoneFormat } from '../../util/phone';
var EditOperationsComponent = /** @class */ (function () {
    function EditOperationsComponent(_matDialogRef, _snackBar, data, _overveiwService) {
        this._matDialogRef = _matDialogRef;
        this._snackBar = _snackBar;
        this._overveiwService = _overveiwService;
        this.isLoading = true;
        this.airport = data.airport || new Airport();
        this.origAirport = Object.assign(new Airport, data.airport);
        this.selectedWindIndicator = this.windIndicator;
        this.selectedSegmentedCircle = this.segmentedCircle;
        this.selectedBeacon = this.airport.beacon === true ? 'Yes' : 'No';
    }
    EditOperationsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_1;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this._matDialogRef.backdropClick().subscribe(function () {
                            _this.close({ cancelBtnClicked: true });
                        });
                        this.formGroup = new FormGroup({
                            masterAirportTower: new FormControl(this.airport.masterAirportTower),
                            fssName: new FormControl(this.airport.fssName),
                            fssPhone: new FormControl(formatPhoneString(this.airport.fssPhone), [Validators.pattern('^([(]\\d{3}[)]\\s\\d{3}[-]\\d{4})$')]),
                            windIndicator: new FormControl(this.selectedWindIndicator),
                            magVariation: new FormControl(this.airport.magVariation),
                            magVariationEpochYear: new FormControl(this.airport.magVariationEpochYear, [Validators.min(1900), Validators.max(2050)]),
                            segmentedCircle: new FormControl(this.selectedSegmentedCircle),
                            beacon: new FormControl(this.selectedBeacon),
                            beaconColor: new FormControl(this.airport.beaconColor)
                        });
                        this.isLoading = false;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this._overveiwService.getFsses()];
                    case 2:
                        _a.fsses = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(EditOperationsComponent.prototype, "windIndicator", {
        get: function () {
            if (this.airport.windIndicator && this.airport.windIndicatorLighted) {
                return 'Lighted';
            }
            return this.airport.windIndicator ? 'Yes' : 'No';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditOperationsComponent.prototype, "segmentedCircle", {
        get: function () {
            if (this.airport.segmentedCircle && this.airport.segmentedCircleLighted) {
                return 'Lighted';
            }
            return this.airport.segmentedCircle ? 'Yes' : 'No';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditOperationsComponent.prototype, "beacon", {
        get: function () {
            var beaconInfo;
            if (this.airport.beacon) {
                beaconInfo = 'Present';
                if (this.airport.beaconColor != null && this.airport.beaconColor.length > 0) {
                    beaconInfo = beaconInfo + ' (' + this.airport.beaconColor + ')';
                }
                return beaconInfo;
            }
            return 'Not Present';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * formats passed in phone number string;
     * @param {string} field
     * @param {string} value
     * @return {string}
     */
    EditOperationsComponent.prototype.formatPhoneNumber = function (field, value) {
        var _a;
        var NEW_NUMBER = formatPhoneString(value);
        this.formGroup.patchValue((_a = {}, _a[field] = NEW_NUMBER, _a));
        return NEW_NUMBER;
    };
    /**
     * event triggered by keyup event on phone number or fax fields
     * @param event
     * @param {string} field
     * @param phoneInputObj
     */
    EditOperationsComponent.prototype.phoneFieldKeyUp = function (event, field, phoneInputObj) {
        var value = this.formGroup.get(field).value;
        var rawValue = undoPhoneFormat(value);
        var KEY = event.key;
        if (KEY === 'Backspace' && rawValue.length === 10 && phoneInputObj.selectionStart === rawValue.length) {
            this.formatPhoneNumber(field, value);
        }
        else if (phoneInputObj.selectionStart < value.length) {
        }
        else if (KEY === 'Backspace' || KEY === 'ArrowLeft' || KEY === 'ArrowRight') {
            return;
        }
        else {
            this.formatPhoneNumber(field, value);
        }
    };
    /**
     * triggered when phone number or fax field goes out of focus
     * @param {string} field
     */
    EditOperationsComponent.prototype.phoneFieldBlur = function (field) {
        var VALUE = this.formGroup.get(field).value;
        if (VALUE === '') {
            return;
        }
        this.formatPhoneNumber(field, VALUE);
    };
    EditOperationsComponent.prototype.getFssId = function (name) {
        var index = this.fsses.findIndex(function (f) { return f.name === name; });
        if (index !== -1) {
            return this.fsses[index].fssId;
        }
        return 'NONE';
    };
    /**
     * triggered when value inside fss dropdown changes; event.value contains fss string .
     * @param {MatSelectChange} event
     * @return {Promise<void>}
     */
    EditOperationsComponent.prototype.fssNameChange = function (event) {
        // if value property is empty return
        if (!event.value) {
            return;
        }
        if (event.value === this.airport.fssName) {
            this.formGroup.patchValue({ fssName: this.airport.fssName || '' });
        }
    };
    /**
     * triggered by save button click event
     * @return {Promise<void>}
     */
    EditOperationsComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        result = void 0;
                        this.airport.masterAirportTower = this.formGroup.value.masterAirportTower;
                        this.airport.fssId = this.getFssId(this.formGroup.value.fssName);
                        this.airport.fssPhone = this.formGroup.value.fssPhone;
                        this.airport.magVariation = this.formGroup.value.magVariation;
                        this.airport.magVariationEpochYear = this.formGroup.value.magVariationEpochYear;
                        this.airport.windIndicator = (this.selectedWindIndicator === 'Lighted' || this.selectedWindIndicator === 'Yes');
                        this.airport.windIndicatorLighted = this.selectedWindIndicator === 'Lighted';
                        this.airport.segmentedCircle = (this.selectedSegmentedCircle === 'Lighted' || this.selectedSegmentedCircle === 'Yes');
                        this.airport.segmentedCircleLighted = this.selectedSegmentedCircle === 'Lighted';
                        this.airport.beacon = !this.selectedBeacon.includes('Not Present');
                        this.airport.beaconColor = this.formGroup.value.beaconColor;
                        return [4 /*yield*/, this._overveiwService.putIslandAirport(this.airport)];
                    case 1:
                        result = _a.sent();
                        this.airport = Airport.parse(result);
                        this.close({ cancelBtnClicked: false, success: true, airport: this.airport });
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        this.close({ cancelBtnClicked: false, success: false, error: e_2 });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * triggered by cancel button click event
     */
    EditOperationsComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    /**
     * closes modal
     * @param data
     */
    EditOperationsComponent.prototype.close = function (data) {
        if (data && data.cancelBtnClicked) {
            Object.assign(this.airport, this.origAirport);
        }
        this._matDialogRef.close(data);
    };
    return EditOperationsComponent;
}());
export { EditOperationsComponent };
